// Pure helpers for the Game Metrics producer / feature group filter. Feature
// groups (dm.di_games.info_feature_group) are per producer — "basic" is a
// different group for every studio — so the group picker only ever offers
// the chosen producer's groups.

export const ALL = 'all';

// Every producer to filter on, alphabetically: the full producer catalog
// (`catalog`, [{ name }] from ask-options) plus any producer seen in the
// feature groups — a producer without feature groups is still a valid filter.
export function producerOptions(catalog, groups) {
  const names = [...catalog.map(c => c.name), ...groups.map(g => g.producer)].filter(Boolean);
  return Array.from(new Set(names)).sort((a, b) => a.localeCompare(b));
}

// The producer's feature groups, most games first.
export function featureGroupOptions(groups, producer) {
  if (producer === ALL) return [];
  return groups
    .filter(g => g.producer === producer)
    .sort((a, b) => b.games - a.games || a.feature_group.localeCompare(b.feature_group));
}

// Request params for the chosen filter; 'all' sends nothing, and a feature
// group is only sent together with its producer.
export function filterParams(producer, featureGroup) {
  if (producer === ALL) return {};
  return featureGroup === ALL ? { producer } : { producer, featureGroup };
}
